import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import { compose, get, formatDate } from '../../utility';
import { withAppUser } from '../../shared/authorization/userConsumer';
import { ROLE_ID } from '../../constants';
import useRequest from '../../util/RequestEsign';
import { UnControlledTable } from '../../shared/table';
import styles from './superAdmin.styles';

function isSuperAdmin(user) {
  if (!user) return false;
  const nodes = get(user, 'systemAclsByUserId.nodes', []);
  return nodes.some(acl => Number(acl.roleId) === ROLE_ID.SUPER_ADMIN);
}

/** react-table v6 passes accessor *values* into sortMethod, not row objects. */
const dateValueTime = (v) => {
  if (v == null || v === '') return 0;
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};

const compareDateValuesAsc = (a, b) => dateValueTime(a) - dateValueTime(b);

const makeColumns = (history) => [
  { Header: 'User', accessor: (row) => `${row.firstName || ''} ${row.lastName || ''}`.trim() || row.email, id: 'user', sortable: true },
  { Header: 'Email', accessor: 'email', sortable: true },
  {
    Header: 'Valid from',
    id: 'validFrom',
    accessor: (row) => row.validFrom || '',
    sortable: true,
    sortMethod: compareDateValuesAsc,
    Cell: ({ value }) => (value ? formatDate(value) : '—'),
  },
  {
    Header: 'Valid to',
    id: 'validTo',
    accessor: (row) => row.validTo || '',
    sortable: true,
    sortMethod: compareDateValuesAsc,
    Cell: ({ value }) => (value ? formatDate(value) : '—'),
  },
  {
    Header: 'Agent',
    id: 'link',
    sortable: false,
    Cell: ({ original }) => (
      <a
        href={`#/admin/agent-management/${original.userId}`}
        onClick={(e) => { e.preventDefault(); history.push(`/admin/agent-management/${original.userId}`); }}
      >
        View agent
      </a>
    ),
  },
];

function SubscriptionsListC({ classes, user, history }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (!isSuperAdmin(user)) return;
    setLoading(true);
    try {
      const list = await useRequest({ endPoint: '/admin/subscriptions' });
      setData(Array.isArray(list) ? list : []);
    } catch {
      setData([]);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    if (!user) return;
    if (!isSuperAdmin(user)) {
      history.replace('/admin');
      return;
    }
    fetchData();
  }, [user, history, fetchData]);

  if (!user || !isSuperAdmin(user)) return null;

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="title">Subscriptions (Super Admin)</Typography>
      {loading ? (
        <Typography color="textSecondary">Loading…</Typography>
      ) : (
        <UnControlledTable
          data={data}
          columns={makeColumns(history)}
          defaultSorted={[{ id: 'validTo', desc: true }]}
        />
      )}
    </div>
  );
}

export default compose(
  withStyles(styles),
  withAppUser,
  withRouter
)(SubscriptionsListC);
